import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

// El VM que ya produces en el listado
export interface CampaignCardVM {
  id: string;
  nameEn: string;
  nameEs: string;
  descriptionEn: string;
  descriptionEs: string;
  targetAmount: number;
  currentAmount: number;
  progressPct: number; // 0..100
  isFeatured: boolean;
  selected: boolean;
}

@Component({
    selector: 'don-campaign-card',
    imports: [CommonModule, TranslateModule],
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.css']
})
export class CampaignCardComponent {
  @Input({ required: true }) campaign!: CampaignCardVM;
  /** Ruta del icono (por si quieres cambiarlo después) */
  @Input() openIconSrc = 'assets/Image/icons-donate/_open-campaign.svg';

  /** Emite el id cuando se hace click */
  @Output() select = new EventEmitter<string>();

  constructor(private translate: TranslateService) {}

  get name(): string {
    return this.translate.currentLang === 'es'
      ? this.campaign.nameEs
      : this.campaign.nameEn;
  }

  get description(): string {
    return this.translate.currentLang === 'es'
      ? this.campaign.descriptionEs
      : this.campaign.descriptionEn;
  }

  onClick(e: Event) {
    e.preventDefault();
    this.select.emit(this.campaign.id);
  }
}
